import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerDMSAutolineConfig } from "models";
import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type AutolineConfig = Pick<
  DealerDMSAutolineConfig,
  | "business_customer_table_id"
  | "customer_table_id"
  | "car_table_id"
  | "customer_detail_table_id"
  | "car_make_table_id"
  | "car_note_table_id"
  | "department_id"
  | "vat_table_id"
  | "price_includes_vat"
  | "rental_billed"
  | "rental_code"
  | "rental_status"
>;

const FormHelper = createFormHelper<AddEditDealerFormPayload>();

export const AutolineConfigSection = () => {
  const { t } = useTranslation();

  return (
    <>
      <Grid columns="equal">
        <GridColumn>
          <Form.Field>
            <label>{t("v8_business_customer_table_id", "Business customer table ID")} </label>
            <FormHelper.Field.Input name="autoline_config.business_customer_table_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_customer_table_id", "Customer table ID")} </label>
            <FormHelper.Field.Input name="autoline_config.customer_table_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_car_table_id", "Car table ID")} </label>
            <FormHelper.Field.Input name="autoline_config.car_table_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_customer_detail_table_id", "Customer detail table ID")} </label>
            <FormHelper.Field.Input name="autoline_config.customer_detail_table_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>
      </Grid>

      <Grid columns="equal">
        <GridColumn>
          <Form.Field>
            <label>{t("v8_car_make_table_id", "Car make table ID")} </label>
            <FormHelper.Field.Input name="autoline_config.car_make_table_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_car_note_table_id", "Car note table ID")} </label>
            <FormHelper.Field.Input name="autoline_config.car_note_table_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_department_id", "Department ID")} </label>
            <FormHelper.Field.Input name="autoline_config.department_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_vat_table_id", "VAT Table ID")} </label>
            <FormHelper.Field.Input name="autoline_config.vat_table_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_price_includes_vat", "Price includes VAT")} </label>
            <FormHelper.Field.Input name="autoline_config.price_includes_vat" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>
      </Grid>

      <Grid columns="equal">
        <GridColumn>
          <Form.Field>
            <label>{t("v8_rental_billed", "Rental billed")} </label>
            <FormHelper.Field.Input name="autoline_config.rental_billed" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_rental_code", "Rental code")} </label>
            <FormHelper.Field.Input name="autoline_config.rental_code" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_rental_status", "Rental status")} </label>
            <FormHelper.Field.Input name="autoline_config.rental_status" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>
      </Grid>
    </>
  );
};
